'use strict';

// Import Libraries
import React from 'react';
// Import JSX Modules
import DecapitalisedTitle         from '../_utils/decapitalised-title';
import AppleDeviceNameCapitaliser from '../_utils/apple-device-name-capitaliser';
// Import JS Modules
import genericHelpers from '../_utils/generic-helpers';

// -----------------------------------------------------------
//  PrismProductAttribute
// -----------------------------------------------------------
const PrismProductAttribute = ({type, value}) => {
  return (
    <li className="list-inline-item">
      <DecapitalisedTitle>{ genericHelpers.tidyTitleFilter(type) }</DecapitalisedTitle>:&nbsp;
      <AppleDeviceNameCapitaliser>{ value }</AppleDeviceNameCapitaliser>
    </li>
  );
};

export default PrismProductAttribute;
